import { render, staticRenderFns } from "./ProfileTopBar.vue?vue&type=template&id=1a9a6fda&scoped=true&"
import script from "./ProfileTopBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileTopBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a6fda",
  null
  
)

export default component.exports